var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ve-page',{ref:"pageIndexArea",staticClass:"page--index",attrs:{"full":true}},[_vm._l((_vm.widgits),function(widget){return [_c(widget.type,{key:widget.id,tag:"component"})]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }